<template>
  <div class="normal-layout-box show-flex-box-c">
    <div class="header-placehoder-box">
      <top-header></top-header>
    </div>

    <div class="view-box">
      <router-view />
    </div>

    <div class="footer-content-box">
      <bottom-footer></bottom-footer>
    </div>

    <div class="login show-flex-box-r">
      <login ref="login" @save-third-login-type="saveThirdLoginType"></login>
    </div>
    <div class="register show-flex-box-r">
      <register ref="register"></register>
    </div>
    <div class="find-password show-flex-box-r">
      <find-password ref="findPassword"></find-password>
    </div>
    <div class="third-login show-flex-box-r">
      <third-login ref="thirdLogin" :curThirdLoginType="curThirdLoginType"></third-login>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/publick/header_cpn";
import bottomFooter from "@/components/publick/footer_cpn";
import login from "@/views/login/login";
import register from "@/views/login/register";
import findPassword from "@/views/login/find_password";
import thirdLogin from "@/views/login/third_code_login";

export default {
  name: "Layout",
  data() {
    return {
      isKeepAlive: false,
      curThirdLoginType:"",
    };
  },
  components: {
    topHeader,
    bottomFooter,
    login,
    register,
    findPassword,
    thirdLogin
  },
  computed: {},
  mounted() {},
  methods: {
    saveThirdLoginType:function(type) {
      console.log(type);
      this.curThirdLoginType = type;
      if(this.curThirdLoginType == "weixin"){
        this.$refs.thirdLogin.colseThirdLoginWin();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.normal-layout-box {
  min-width: 100%;
  min-height: 100%;
  // background: #F5F5F9;
  .header-placehoder-box {
    height: 70px;
    flex-shrink: 0;
  }
  .view-box {
    // width: 1200px;
    // margin: 0 auto;
    flex-grow: 1;
  }
   .footer-content-box {
    height: 306px;
    flex-shrink: 0;
    background: #302929;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue